import { LicenseType } from "../components/manage-template/manage-template.model";
import { TemplateDetail } from "./manage-template.interface";

export enum TemplateCategory {
    NOTE = 'note',
    DOCUMENT = 'document',
    LETTER = 'letter'
}

export enum Privacy {
    GLOBAL = 'global',
    TEAM = 'team',
    INDIVIDUAL = 'individual'
}

export enum CreatedBy {
    ME = 'me',
    TEAM = 'team',
    SYSTEM = 'system'
}

export interface ITemplate {
    name: string,
    description: string,
    icon?: string,
    identifier: string;
    starred: boolean;
    isCustomTemplate: boolean;
}

export interface ITemplateList {
    category: TemplateCategory | 'Favorites';
    items: ITemplate[];
}


export enum Identifier {
    TRANSCRIPT = 'transcription',
    SOAP = 'soap',
    ISSUE_LIST = 'issue_list',
    ISSUE_LIST_LITE = 'issue_list_lite',
    ISSUE_LIST_CLASSIC = 'issue_list_classic',
    SOAP_LITE = 'soap_lite',
    SOAP_CLASSIC = 'soap_classic',
    TRIAGE_NOTES = 'triage_note',
    MEDICAL_CERTIFICATE = 'certificate',
    LETTER_TO_REFERRER = 'referrer',
    REFERRAL = 'referral',
    RPM_REFERRAL = 'rpm_referral',
    INTRA_OPERATIVE_PROCEDURES = 'intra',
    POST_OPERATIVE_SURGICAL_NOTES = 'surgical_postop',
    POST_OP = 'postop'
}

export enum TAB_ITEM {
    TRANSCRIPT = 'Transcript',
    SOAP = 'SOAP',
    ISSUE_LIST = 'Issues List',
    ISSUE_LIST_LITE = 'Issues List Lite',
    ISSUE_LIST_CLASSIC = 'Issues List Classic',
    SOAP_LITE = 'SOAP Lite',
    SOAP_CLASSIC = 'SOAP Classic',
    TRIAGE_NOTE = 'Triage Note',
    CERTIFICATE = 'Medical Certificate',
    REFERRER = 'Letter To Referrer',
    REFERRAL = 'Referral',
    RPM_REFERRAL = 'rpm_referral',
    INTRA = 'Intra-Operative Procedures',
    SURGICAL_POSTOP = 'Post Operative Surgical Notes',
    POSTOP = 'Post-Op Note'
  }

export interface IResponse {
    template: TemplateDetail,
    currentLicenseType: LicenseType
}

export interface IAddTemplateResponse {
    isTourTaken: boolean,
    currentLicenseType: LicenseType
}